<ng-container *ngFor="let item of remindersData; let i = index">
  <nb-accordion *ngIf="remindersData.length" class="request-accordion">
    <nb-accordion-item class="request-list-container">
      <nb-accordion-item-header>
        <div class="request-list" fxLayout="row">
          <div class="request-title">
            <span>{{ remindersHeading[i] }}</span>
          </div>
        </div>
      </nb-accordion-item-header>
      <nb-accordion-item-body>
        <ng-container>
          <div class="reminders-content">
            <div class="content-body" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="content" fxFlex="70">
                {{ item.title }}
              </div>
              <div class="time" fxFlex="30" fxFlex.lt-sm="40" fxLayout="row" fxLayoutAlign="center center">
                {{ item?.dueDate }}
              </div>
            </div>
          </div>
        </ng-container>
      </nb-accordion-item-body>
    </nb-accordion-item>
  </nb-accordion>
</ng-container>